import { render, staticRenderFns } from "./PatientEdit.vue?vue&type=template&id=4847f98e&"
import script from "./PatientEdit.vue?vue&type=script&lang=ts&"
export * from "./PatientEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports